import React from 'react';

import { IIcon } from '../types/IIcon';

import '../../../assets/fontAwesome/css/all.css';
import '../../../common/styles/globalClasses.scss';
import './icon.scss';

const Icon: React.FC<IIcon> = ({ name, className, onClick, disabled, id, style }) => {
  return (
    <span id={id} className={className + ` ${disabled ? 'disabled' : ''}`} onClick={!disabled ? onClick : undefined}
          style={style}>
      <i id={id} className={name} />
    </span>
  );
};
export default Icon;
